<template>
  <div v-if="showMode" class="staticInfoClass dy3dDialog">
    <div class="headerClass">
      <div class="stepInfo">
        <span :class="currentStep == 0 ? 'spanClass primaryColor' : ''" @click="clickStep('0')">显示字段设置</span>
        <a-divider type="vertical" />
        <span :class="currentStep == 1 ? 'spanClass primaryColor' : ''" @click="clickStep('1')">统计字段设置</span>
        <a-divider type="vertical" />
        <span :class="currentStep == 2 ? 'spanClass primaryColor' : ''" @click="clickStep('2')">分类统计设置</span>
      </div>
      <span @click="close()"><a-icon type="close" style="color: aliceblue; cursor: pointer" /></span>
    </div>
    <div class="contentInfo">
      <a-table
        class="tableHeaderClass"
        ref="table"
        bordered
        size="middle"
        rowKey="bsm"
        :scroll="{ x: true, y: 270 }"
        :rowSelection="currentStep == 0 
                        ? {
                          selectedRowKeys: bdcRowKeys,
                          onChange: onSelectChange,
                          getCheckboxProps: getCheckboxProps,
                          type: 'checkbox',
                        } 
                        : {
                          selectedRowKeys: bdcRowKeys,
                          onChange: onSelectChange,
                          type: 'checkbox',
                        }"
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
      >
        <template slot="order" slot-scope="text, record">
          <editable-cell :text="text" :cellType="cellCxpx" @change2="onCellChange(record.key, 'order', $event)" />
        </template>
        <template slot="xh" slot-scope="text, record">
          <a-icon type="arrow-up" @click="move(text, record, 'up')" v-if="canMove(record, 'up')"></a-icon>
          <a-divider type="vertical" v-if="canMove(record, 'up') && canMove(record, 'down')" />
          <a-icon type="arrow-down" @click="move(text, record, 'down')" v-if="canMove(record, 'down')"></a-icon>
        </template>
      </a-table>
    </div>
    <div class="btnsClass">
      <a-button class="primaryBtn" @click="finished">完成</a-button>
    </div>
  </div>
</template>
  
<script>
import EditableCell from '../../../components/editCellDialog.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'setStaticInfoDialog',
  components: {
    EditableCell,
  },
  data() {
    return {
      showMode: false,
      currentStep: 0,
      cellCxpx: 'order',
      cellXspx: 'xh',
      columns1: [
        {
          title: '字段',
          dataIndex: 'mc',
          align: 'center',
          width: 200,
        },
        {
          title: '别名',
          dataIndex: 'alias',
          align: 'center',
          width: 200,
        },
        {
          title: '查询排序',
          dataIndex: 'order',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'order' },
          // customRender: (text, record) => {
          //     return text == '0' ? '无' : text == '1' ? '升序' : '降序'
          // }
        },
        {
          title: '排序',
          dataIndex: 'xh',
          align: 'center',
          // width:120,
          scopedSlots: { customRender: 'xh' },
        },
      ],
      columns2: [
        {
          title: '字段',
          dataIndex: 'name',
          align: 'center',
          width: 180,
        },
        {
          title: '别名',
          dataIndex: 'alias',
          align: 'center',
          width: 300,
        },
        {
          title: '排序',
          dataIndex: 'xh',
          align: 'center',
          // width:120
          scopedSlots: { customRender: 'xh' },
        },
      ],
      columns3: [
        {
          title: '字段',
          dataIndex: 'name',
          align: 'center',
          width: 180,
        },
        {
          title: '别名',
          dataIndex: 'alias',
          align: 'center',
          width: 300,
        },
        {
          title: '排序',
          dataIndex: 'xh',
          align: 'center',
          // width:120
          scopedSlots: { customRender: 'xh' },
        },
      ],
      tableData1: [],
      bdcRowKeys1: [],
      csArr1: [],

      tableData2: [],
      bdcRowKeys2: [],
      csArr2: [],

      tableData3: [],
      bdcRowKeys3: [],
      csArr3: [],
    }
  },
  computed: {
    columns() {
      if (this.currentStep == 0) {
        return this.columns1
      } else if (this.currentStep == 1) {
        return this.columns2
      } else {
        return this.columns3
      }
    },
    tableData() {
      if (this.currentStep == 0) {
        return this.tableData1
      } else if (this.currentStep == 1) {
        return this.tableData2
      } else {
        return this.tableData3
      }
    },
    bdcRowKeys() {
      if (this.currentStep == 0) {
        return this.bdcRowKeys1
      } else if (this.currentStep == 1) {
        return this.bdcRowKeys2
      } else {
        return this.bdcRowKeys3
      }
    },
  },
  methods: {
    // 获取当前用户信息
    ...mapGetters(['userInfo']),
    /** 
     * 初始化弹框信息
     * @param {arr} msg  选择的图层的所有属性
     * @param {string} action 触发的操作：新增、编辑、查看
     * @param {arr} checkedTableData 选中的配置信息数据
     */
    setMap(msg, action, checkedTableData) {
      console.log('打开弹框',msg,action,checkedTableData);
      this.showMode = true
      if(action != '编辑'){
        this.currentStep = 0
        this.tableData1 = JSON.parse(JSON.stringify(msg)) 
        this.bdcRowKeys1 = []
        this.csArr1 = []
        this.tableData2 = []
        this.bdcRowKeys2 = []
        this.csArr2 = []
        this.tableData3 = []
        this.bdcRowKeys3 = []
        this.csArr3 = []
        this.tableData1.map((item, index) => {
          // 查询排序默认是 升序
          item.order = '1'
          item.mc = item.name
          item.xh = String(index + 1)
          item.key = String(index)
          if (item.statisticsOrNot) {
            this.tableData2.push(item)
          }
          if (item.groupOrNot) {
            this.tableData3.push(item)
          }
        })

        if(action == '查看'){
          // 从我的收藏跳转过来的
          this.csArr1 = this.matchCheckedData(this.tableData1,checkedTableData)
          this.bdcRowKeys1 = this.csArr1.map(item => item.bsm)
          this.csArr2 = this.matchCheckedData(this.tableData2,checkedTableData)
          this.bdcRowKeys2 = this.csArr2.map(item => item.bsm)
          this.csArr3 = this.matchCheckedData(this.tableData3,checkedTableData)
          this.bdcRowKeys3 = this.csArr3.map(item => item.bsm)
        }
      }
    },
    // 根据配置统计信息的表格数据，对应的在弹框表格里勾选上
    matchCheckedData(data,allCheckedData){
      let resultArr = allCheckedData.map(item2 => {
        const matchingItem = data.find(item1 => item1.bsm === item2.bsm);
        // 如果找到匹配的对象，返回data中的对象
        if (matchingItem) {
          return matchingItem;
        }
        // 如果没有找到匹配的对象，返回null或其他合适的值
        return null;
      }).filter(Boolean);
      return resultArr
    },
    // 点击第几个表
    clickStep(step) {
      this.currentStep = step
    },
    // 判断表格行数据能否上移 下移
    canMove(record, direction) {
      let canMoveTr = true
      let tableData = this.tableData
      for (let i = 0; i < tableData.length; i++) {
        if (direction == 'up') {
          if (tableData[i].bsm == record.bsm && i == 0) {
            // 说明数据已经在第一个了
            canMoveTr = false
            break
          }
        } else if (direction == 'down') {
          if (tableData[i].bsm == record.bsm && i == tableData.length - 1) {
            // 说明数据已经在最后一个了
            canMoveTr = false
            break
          }
        }
      }
      return canMoveTr
    },
    // 上移 下移
    move(xh, record, direction) {
      // 找到被移动的数据在数组里的下标
      let targetDataIndex = this.tableData.findIndex((item) => item.bsm == record.bsm)
      // 找到移动时的参考数据
      let referenceData = null
      if (direction == 'up') {
        referenceData = JSON.parse(JSON.stringify(this.tableData[targetDataIndex - 1]))
      } else {
        referenceData = JSON.parse(JSON.stringify(this.tableData[targetDataIndex + 1]))
      }
      // 因为tableData1是总数据，所以直接在里面找到这两个对象并交换他们的xh
      this.tableData1.map((item) => {
        if (item.bsm == record.bsm) {
          item.xh = referenceData.xh
        }
        if (item.bsm == referenceData.bsm) {
          item.xh = xh
        }
      })
      // 重新排序
      this.sortTableData()
    },
    // 按xh给数组排序
    sortTableData() {
      this.tableData1.sort((a, b) => a.xh - b.xh)
      // 更新其他两张表的序号
      this.tableData2.map((item) => {
        item.xh = this.tableData1.filter((e) => e.bsm == item.bsm)[0].xh
      })
      this.tableData3.map((item) => {
        item.xh = this.tableData1.filter((e) => e.bsm == item.bsm)[0].xh
      })
      this.tableData2.sort((a, b) => a.xh - b.xh)
      this.tableData3.sort((a, b) => a.xh - b.xh)
    },
    // 复选框禁用(该方法暂不需要)
    getCheckboxProps(record) {
      // 加载表格的时候直接就可以拿到table所有的data数据 record是获取到表格data每一行的数据
      return {
        props: {
          // name里面去写你要禁用表格(那一列的状态值来进行禁用)  比方说我表格columns数据里面有个status( dataIndex: 'status')
          // name: record.mc,
          // disabled里面写你要根据后台传来的值进行禁用  比方说我们的需求是(后台传来三个值分别是{1,2,3})当status 的值是1和2时禁用当前表格的复选框
          // disabled: record.mc == 'BSM' || record.mc == 'DLBM' || record.mc == 'DLMC'
          //           || record.mc == 'OBJECTID' || record.mc == 'Shape' || record.mc == 'Shape_Length'
          //           || record.mc == 'Shape_Area' || record.mc == 'BFMJ',
          // 如果代码不生效 那么就是你rowKey的问题 没有对应的唯一值 (如果不知道怎么解决 麻烦翻翻我博客园里面有解决方法)
        },
      }
    },
    // 可编辑单元格（查询排序）
    onCellChange(key, dataIndex, value) {
      console.log('查询排序',key, dataIndex, value);
      const dataSource = [...this.tableData1]
      const target = dataSource.find((item) => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.tableData1 = dataSource
      }
    },
    // 复选框点击事件
    onSelectChange(bdcRowKeys, records) {
      if (this.currentStep != 0) {
        let currentStep = Number(this.currentStep)
        this[`bdcRowKeys${currentStep + 1}`] = bdcRowKeys
        this[`csArr${currentStep + 1}`] = records
        // 说明：表1指显示字段表，表2指统计字段表，表3指分类统计表
        // 当点击的是表2或表3时，先把1勾选的数据里包含2或3的数据过滤掉，目的是为了保留1里面其余数据的勾选情况
        this[`tableData${currentStep + 1}`].map((item) => {
          this.bdcRowKeys1 = this.bdcRowKeys1.filter((key) => key != item.bsm)
          this.csArr1 = this.csArr1.filter((data) => data.bsm != item.bsm)
        })
        // 再把保留下来的数据和其他表里勾选的数据合并
        this.bdcRowKeys1 = [...this.bdcRowKeys1, ...bdcRowKeys]
        this.csArr1 = [...this.csArr1, ...records]
      }
      if (this.currentStep == 0) {
        // 勾选显示字段设置表格的复选框时  不要和统计、分组字段联动，排序要联动
        this.bdcRowKeys1 = bdcRowKeys
        // this.bdcRowKeys2 = []
        // this.bdcRowKeys3 = []
        this.csArr1 = records
        // this.csArr2 = []
        // this.csArr3 = []
        // records.map((record) => {
        //   let targetData2 = this.tableData2.filter((data) => data.bsm == record.bsm)
        //   let targetData3 = this.tableData3.filter((data) => data.bsm == record.bsm)
        //   if (targetData2.length > 0) {
        //     this.bdcRowKeys2.push(targetData2[0].bsm)
        //     this.csArr2.push(targetData2[0])
        //   }
        //   if (targetData3.length > 0) {
        //     this.bdcRowKeys3.push(targetData3[0].bsm)
        //     this.csArr3.push(targetData3[0])
        //   }
        // })
      }
    },
    // 复选框禁用
    getCheckboxProps(record) {
      // console.log('复选框禁选',record);
      // 判断显示字段里有没有是统计字段或者分类字段的，且是勾选上的，如果有，则不让取消勾选
      let hasTjData = this.csArr2.filter(e => e.bsm == record.bsm)
      let hasFlData = this.csArr3.filter(e => e.bsm == record.bsm)
      return {
        props: {
          // name里面去写你要禁用表格(那一列的状态值来进行禁用)  比方说我表格columns数据里面有个status( dataIndex: 'status')
          // name: record.mc,
          // disabled里面写你要根据后台传来的值进行禁用  比方说我们的需求是(后台传来三个值分别是{1,2,3})当status 的值是1和2时禁用当前表格的复选框
          disabled: hasTjData.length > 0 || hasFlData.length > 0
          // disabled: record.mc == 'BSM' || record.mc == 'DLBM' || record.mc == 'DLMC'
          //           || record.mc == 'OBJECTID' || record.mc == 'Shape' || record.mc == 'Shape_Length'
          //           || record.mc == 'Shape_Area' || record.mc == 'BFMJ',
          // 如果代码不生效 那么就是你rowKey的问题 没有对应的唯一值 (如果不知道怎么解决 麻烦翻翻我博客园里面有解决方法)
        },
      };
    },
    // 完成并组装数据
    finished() {
      if (this.csArr2.length === 0) {
        this.$message.warning('请勾选统计字段')
        return
      }
      if (this.csArr3.length === 0) {
        this.$message.warning('请勾选分类字段')
        return
      }
      let newArry = JSON.parse(JSON.stringify(this.csArr1))
      for (var i = 0; i < newArry.length; i++) {
        for (var j = 0; j < this.csArr2.length; j++) {
          if (this.csArr2[j].name == newArry[i].name) {
            newArry[i].istj = true
          }
        }
      }
      for (var k = 0; k < newArry.length; k++) {
        for (var n = 0; n < this.csArr3.length; n++) {
          if (this.csArr3[n].name == newArry[k].name) {
            newArry[k].isfl = true
          }
        }
      }
      for (var item of newArry) {
        if (!item.istj) {
          item.istj = false
        }
        if (!item.isfl) {
          item.isfl = false
        }
      }
      this.$emit('getStaticData', newArry)
      this.close()
    },
    // 关闭
    close() {
      this.showMode = false
    },
  },
}
</script>
  
<style lang="less" scoped>
/**infoview浮动面板*/
.staticInfoClass {
  z-index: 100;
  backdrop-filter: blur(8px);
  position: absolute;
  top: 20%;
  width: 700px;
  height: 400px;
  right: 520px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
  .headerClass {
    width: 100%;
    height: 40px;
    opacity: 0.8;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    .stepInfo {
      span {
        color: rgba(255, 255, 255, 0.5);
        cursor: pointer;
      }
      .spanClass {
        color: #fff;
      }
    }
  }
  .contentInfo {
    width: 100%;
  }
  .btnsClass {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}

.staticInfoClass input,
.staticInfoClass select,
.staticInfoClass textarea {
  color: #ffffff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
  font-size: 14px;
}
/deep/ .ant-row.ant-form-item {
  margin-bottom: 0px;
  // 不要校验提示
  .ant-form-explain {
    display: none;
  }
}
/deep/ .anticon-arrow-up,
/deep/ .anticon-arrow-down {
  color: rgba(255, 255, 255, 0.5);
}
/deep/ .ant-table-body {
  height: calc(100% - 42px);
}
</style>
  